/// <amd-module name="Search/Wiki/Components/FilterPaneContainer" />

import * as React from "react";
import * as Container from "Search/Shared/Base/Container";
import * as FilterPane from "Search/Wiki/Components/FilterPane";
import { ActionCreator } from "Search/Wiki/Flux/ActionCreator";
import { StoreName, StoresHub, IAggregatedState } from "Search/Wiki/Flux/StoresHub";

export const FilterPaneContainer = Container.create<StoreName, ActionCreator, IAggregatedState, StoresHub>(
    ["filterStore"],
    ({ filterStoreState, searchStoreState, isProjectContext }, props) => {
        const { filterItemsVisible } = filterStoreState;
        return (
            <>
                {
                    filterItemsVisible ? (
                        <div className="search-filters-container wiki-filters-container">
                            <FilterPane.FilterPane
                                searchStoreState={searchStoreState}
                                filterStoreState={filterStoreState}
                                isProjectContext={isProjectContext}
                                {...props} />
                        </div>
                    ) : null
                }
            </>
        );
    }); 
